import { render, staticRenderFns } from "./form-update.vue?vue&type=template&id=6c71f2a8"
import script from "./form-update.vue?vue&type=script&lang=js"
export * from "./form-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports